import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputGroup, InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { VehicleModelItem } from '../../api/vehicles';
import { VehicleModelsService } from '../../service/vehicle-models.service';

@Component({
  selector: 'app-vehicle-models',
  standalone: true,
  imports: [CommonModule,CardModule,InputTextModule,TableModule,ButtonModule,InputGroupModule,FormsModule,ReactiveFormsModule],
  templateUrl: './vehicle-models.component.html',
  styleUrl: './vehicle-models.component.scss'
})
export class VehicleModelsComponent {
  searchForm!: FormGroup;
  models!: VehicleModelItem[];

  constructor(private router: Router,private fb: FormBuilder, private vehicleModelsService: VehicleModelsService) {}

  ngOnInit(){
    this.initializeForm();
  }

  initializeForm(){
    this.searchForm = this.fb.group({
      search: ['']
    })
  }

  

  searchModelClicked(){
  }

  addModelClicked(){
    this.router.navigate(['/home/vehicle-models/new'])
  }
}
